import React from 'react';
import TermsContent from 'components/admin/terms/TermsContent';

export const TermsPage: React.FC = () => {
  return <TermsContent />;
};
